import React from "react";
import parse, {
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";
import { twMerge } from "tailwind-merge";

interface PropTypes {
  value: string;
  textColor?: "text-darkPurple" | "text-darkText";
  className?: string;
}

const RichTextRenderer = ({ value, className }: PropTypes) => {
  const baseStyle = "font-light";

  type TagName = "p" | "ul" | "ol" | "h1" | "h2" | "h3" | "table";

  const tagStyles: { [key in TagName]: string } = {
    // When editing styles, temporarily extract desired tag styles to a variable called className to get auto-complete
    p: "font-body leading-[130%] tracking-[.32px] [&_a]:font-normal [&_a]:underline text-darkText lg:text-lg [&_a]:underline",
    ul: "list-disc py-7 pl-8 [&_li]:mb-3",
    ol: "list-decimal py-7 pl-8 [&_li]:mb-3",
    h1: "font-heading text-4xl font-bold italic text-armyGreen md:text-6xl lg:text-7xl lg:leading-[110%] [&_strong]:font-extrabold",
    h2: "font-heading text-[28px] font-bold italic leading-[115%] tracking-[1.12px] text-darkText md:text-3xl lg:text-4xl lg:leading-[110%] lg:tracking-[1.44px] [&_strong]:font-extrabold",
    h3: "font-heading text-xl font-light italic leading-[125%] tracking-[0.72px] text-armyGreen [&_strong]:font-bold",
    table:
      "mx-auto max-w-[800px] border-separate border-spacing-[3px] [&_td]:justify-center [&_td]:px-2 [&_td]:py-1 md:[&_td]:p-4 [&_td]:[&_tr:not(:first-child)]:bg-mint first:[&_tr]:bg-armyGreen first:[&_tr]:text-white first:[&_td]:[&_tr]:bg-armyGreen first:[&_td]:first:[&_tr]:bg-extraDarkPurple first:[&_td]:[&_tr]:text-white",
  };

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.name in tagStyles) {
        const tagName = domNode.name as TagName; // Type assertion
        const mergedClass = twMerge(baseStyle, tagStyles[tagName], className);
        return React.createElement(
          domNode.name,
          { className: mergedClass },
          domToReact(domNode.children, options),
        );
      }
    },
  };

  return <>{parse(value, options)}</>;
};

export default RichTextRenderer;
